import { SessionContextDto } from './session-context.dto';

export class BotResponseDto {
  replies: string[];
  replySessionContext: SessionContextDto;
}
